import Cookie from 'js-cookie';

export default function(API) {

	API.cookie = Cookie; 
}
